import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface DataTableWrapperProps {
  title?: string;
  description?: string;
  toolbar?: ReactNode;
  filters?: ReactNode;
  children: ReactNode;
  emptyState?: ReactNode;
  isLoading?: boolean;
  className?: string;
}

export function DataTableWrapper({
  title,
  description,
  toolbar,
  filters,
  children,
  emptyState,
  isLoading,
  className,
}: DataTableWrapperProps) {
  return (
    <div className={cn('space-y-4', className)}>
      {(title || description || toolbar) && (
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            {title && (
              <h2 className="text-lg font-semibold text-foreground mb-1">
                {title}
              </h2>
            )}
            {description && (
              <p className="text-sm text-muted-foreground">
                {description}
              </p>
            )}
          </div>
          {toolbar && (
            <div className="flex items-center gap-2 flex-shrink-0">
              {toolbar}
            </div>
          )}
        </div>
      )}
      {filters && (
        <div className="flex items-center gap-2 flex-wrap">
          {filters}
        </div>
      )}
      {isLoading ? (
        <div className="bg-card rounded-xl border border-border/40 p-6">
          {children}
        </div>
      ) : (
        <div className="bg-card rounded-xl border border-border/40 overflow-hidden">
          {children}
        </div>
      )}
    </div>
  );
}

